<template>
    <div>
        <div class="columns">
            <div class="column">
                <h2 class="title is-3">Пользователь {{ profileId }}</h2>
            </div>
        </div>
        <div class="columns">
            <div class="column is-6" v-if="!loading_user">
                <section>
                    <b-field horizontal label="Дата регистрации:">
                        <b-input v-model="profile.created_at" readonly></b-input>
                    </b-field>
                    <b-field horizontal label="Имя:">
                        <b-input v-model="profile.name" readonly></b-input>
                    </b-field>
                    <b-field horizontal label="Отчество:">
                        <b-input v-model="profile.second_name" readonly></b-input>
                    </b-field>
                    <b-field horizontal label="Фамилия:">
                        <b-input v-model="profile.surname" readonly></b-input>
                    </b-field>
                    <b-field horizontal label="Телефон:" :type="type(profile.is_phone_confirm)">
                        <b-input v-model="profile.phone" readonly></b-input>
                    </b-field>
                    <b-field horizontal label="Email:" :type="type(profile.is_email_confirm)">
                        <b-input v-model="profile.email" readonly></b-input>
                    </b-field>
                    <b-field horizontal label="aff_sub1:">
                        <b-input v-model="profile.aff_sub1" readonly></b-input>
                    </b-field>
                    <b-field horizontal label="aff_sub2:">
                        <b-input v-model="profile.aff_sub2" readonly></b-input>
                    </b-field>
                    <b-field horizontal label="aff_sub3:">
                        <b-input v-model="profile.aff_sub3" readonly></b-input>
                    </b-field>
                    <b-field horizontal label="aff_sub5:">
                        <b-input v-model="profile.aff_sub5" readonly></b-input>
                    </b-field>
                    <b-field horizontal label="is_sms_blocked:">
                        <b-select v-model="profile.is_sms_blocked" @input="changeBlock()" readonly>
                            <option value="false">Нет</option>
                            <option value="true">Да</option>
                        </b-select>
                    </b-field>
                </section>
            </div>
            <div class="column is-6" v-if="!loading_user">
                <section>
                    <b-field horizontal label="Дата изменения:">
                        <b-input v-model="profile.updated_at" readonly></b-input>
                    </b-field>
                    <b-field horizontal label="utm_source:">
                        <b-input v-model="profile.utm_source" readonly></b-input>
                    </b-field>
                    <b-field horizontal label="utm_campaign:">
                        <b-input v-model="profile.utm_campaign" readonly></b-input>
                    </b-field>
                    <b-field horizontal label="utm_content:">
                        <b-input v-model="profile.utm_content" readonly></b-input>
                    </b-field>
                    <b-field horizontal label="utm_medium:">
                        <b-input v-model="profile.utm_medium" readonly></b-input>
                    </b-field>
                    <b-field horizontal label="utm_term:">
                        <b-input v-model="profile.utm_term" readonly></b-input>
                    </b-field>
                </section>
            </div>
        </div>
        <div>
            <b-button
                class="button is-primary"
                slot="trigger"
                style="margin: 5px;"
                :icon-right="opened_optional ? 'chevron-up' : 'chevron-down'"
                @click="opened_optional = !opened_optional"
                >Дополнительно</b-button
            >
            <div v-if="opened_optional && !loading_user">
                <div class="columns">
                    <div class="column is-6">
                        <section>
                            <b-field horizontal label="Не активен:">
                                <b-input v-model="profile.not_active" readonly></b-input>
                            </b-field>
                            <b-field horizontal label="Адрес:">
                                <b-input v-model="profile.address" readonly></b-input>
                            </b-field>
                            <b-field horizontal label="Дата рождения:">
                                <b-input v-model="profile.birthday" readonly></b-input>
                            </b-field>
                        </section>
                    </div>
                    <div class="column is-6">
                        <section>
                            <b-field horizontal label="uuid:">
                                <b-input v-model="profile.uuid" readonly></b-input>
                            </b-field>
                            <b-field horizontal label="api_key:">
                                <b-input v-model="profile.api_key" readonly></b-input>
                            </b-field>
                            <b-field horizontal label="token:">
                                <b-input v-model="profile.token" readonly></b-input>
                            </b-field>
                            <b-field horizontal label="refresh_token:">
                                <b-input v-model="profile.refresh_token" readonly></b-input>
                            </b-field>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <b-button
                class="button is-primary"
                slot="trigger"
                style="margin: 5px;"
                :icon-right="opened_deals ? 'chevron-up' : 'chevron-down'"
                @click="opened_deals = !opened_deals"
                >Сделки</b-button
            >
            <div v-if="opened_deals && !loading_deals">
                <div class="columns">
                    <div class="column">
                        <section>
                            <b-table
                                :data="profile.deals"
                                :loading="loading_deals"
                                :opened-detailed="defaultOpenedDetails"
                                detailed
                                detail-key="id"
                            >
                                <template slot-scope="props">
                                    <b-table-column field="id" label="ID" numeric sortable>
                                        {{ props.row.id }}
                                    </b-table-column>

                                    <b-table-column field="profile_id" label="Пользователь">
                                        {{ props.row.profile.email }} (ID:
                                        {{ props.row.profile.id }})
                                    </b-table-column>

                                    <b-table-column field="utm_source" label="utm_source">
                                        {{ props.row.profile.utm_source }}
                                    </b-table-column>

                                    <b-table-column field="aff_sub4" label="aff_sub4">
                                        {{ props.row.postbackAffSub4 }}
                                    </b-table-column>

                                    <b-table-column field="created_at" label="Дата заявки" sortable>
                                        {{ props.row.created_at }}
                                    </b-table-column>

                                    <b-table-column field="name" label="Оффер">
                                        {{ props.row.offer.name }}
                                    </b-table-column>

                                    <b-table-column field="payout" label="Выплата" sortable>
                                        {{ props.row.postbackPayoutFormatted }}
                                    </b-table-column>

                                    <b-table-column field="currency" label="Валюта">
                                        {{ props.row.postbackCurrency }}
                                    </b-table-column>

                                    <b-table-column field="status" label="Статус" sortable>
                                        <span :class="props.row.postbackStatusFormatted">
                                            {{ props.row.postbackStatusFormatted }}
                                        </span>
                                    </b-table-column>
                                </template>

                                <template slot="detail" slot-scope="props">
                                    <b-table
                                        :data="props.row.postbacks"
                                        :columns="nestedColumns"
                                    ></b-table>
                                </template>
                            </b-table>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <b-button
                class="button is-primary"
                slot="trigger"
                style="margin: 5px;"
                :icon-right="opened_notifications ? 'chevron-up' : 'chevron-down'"
                @click="opened_notifications = !opened_notifications"
                >Уведомления</b-button
            >
            <div v-if="opened_notifications && !loading_notifications">
                <div class="columns">
                    <div class="column">
                        <section>
                            <b-tabs v-model="selectedType" :multiline="multiline" vertical v-on:change="updateOffer">
                                <template v-for="tab in profile.notifications">
                                    <b-tab-item
                                        v-if="tab.type"
                                        :key="tab.type"
                                        :value="tab.type"
                                        :label="tab.type"
                                        style="margin: -16px;">
                                        <b-tabs v-model="selectedNotifType" :multiline="multiline" vertical>
                                            <b-tab-item label="Цепочки" style="margin-top: -10px;">
                                                <label v-if="tab.chains.length === 0">Нет цепочек</label>
                                                <b-field label="Оффер" v-if="tab.chains.length !== 0">
                                                    <b-select placeholder="Выберите оффер" v-model:value="selectedOffer">
                                                        <option value="">Все</option>
                                                        <option
                                                            v-for="options in filter_offers(tab.chains)"
                                                            :value="option">
                                                            {{ options }}
                                                        </option>
                                                    </b-select>
                                                </b-field>
                                                <b-table
                                                    :data="filter_items(tab.chains, selectedOffer)"
                                                    :default-sort="['order', 'asc']"
                                                    v-if="tab.chains.length !== 0"
                                                >
                                                    <template slot-scope="props">
                                                        <b-table-column field="order" label="Этап" sortable>
                                                            {{ props.row.order }}
                                                        </b-table-column>
                                                        <b-table-column field="name" label="Название" sortable>
                                                            {{ props.row.name }}
                                                        </b-table-column>
                                                        <b-table-column field="count" label="Количество" sortable>
                                                            {{ props.row.count }}
                                                        </b-table-column>
                                                    </template>
                                                </b-table>
                                            </b-tab-item>
                                            <b-tab-item label="Другие" style="margin-top: -7px;">
                                                <label>Количество: {{tab.instant}}</label>
                                            </b-tab-item>
                                        </b-tabs>
                                    </b-tab-item>
                                </template>
                            </b-tabs>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <b-button
                class="button is-primary"
                slot="trigger"
                style="margin: 5px;"
                @click="opened_utms = !opened_utms"
                :icon-right="opened_utms ? 'chevron-up' : 'chevron-down'"
                >Метки</b-button
            >
            <div v-if="opened_utms && !loading_user">
                <div class="columns">
                    <div class="column">
                        <section>
                            <b-table
                                v-if="profile.utms"
                                :data="profile.utms"
                                :loading="loading_user"
                            >
                                <template slot-scope="props">
                                    <b-table-column field="created_at" label="Дата" sortable>
                                        {{ props.row.created_at }}
                                    </b-table-column>
                                    <b-table-column field="utm_source" label="utm_source" sortable>
                                        {{ props.row.utm_source }}
                                    </b-table-column>
                                    <b-table-column
                                        field="utm_campaign"
                                        label="utm_campaign"
                                        sortable
                                    >
                                        {{ props.row.utm_campaign }}
                                    </b-table-column>
                                    <b-table-column
                                        field="utm_content"
                                        label="utm_content"
                                        sortable
                                    >
                                        {{ props.row.utm_content }}
                                    </b-table-column>
                                    <b-table-column field="utm_medium" label="utm_medium" sortable>
                                        {{ props.row.utm_medium }}
                                    </b-table-column>
                                    <b-table-column field="utm_term" label="utm_term" sortable>
                                        {{ props.row.utm_term }}
                                    </b-table-column>
                                </template>
                            </b-table>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <b-button
                class="button is-primary"
                slot="trigger"
                style="margin: 5px;"
                :icon-right="opened_actions ? 'chevron-up' : 'chevron-down'"
                @click="opened_actions = !opened_actions"
            >
                Действия
            </b-button>
            <div v-if="opened_actions && !loading_actions">
                <div class="columns">
                    <div class="column">
                        <section>
                            <b-table
                                v-if="profile.actions"
                                :data="profile.actions"
                                :loading="loading_actions"
                            >
                                <template slot-scope="props">
                                    <b-table-column field="created_at" label="Дата" sortable>
                                        {{ props.row.created_at }}
                                    </b-table-column>
                                    <b-table-column field="event" label="Событие" sortable>
                                        {{ props.row.event }}
                                    </b-table-column>
                                    <b-table-column field="args" label="Параметры" sortable>
                                        {{ props.row.args }}
                                    </b-table-column>
                                </template>
                            </b-table>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PostbackStatuses from "@/app/admin/postbacks/shared/services/postbackStatuses";

export default {
    name: "userDetails",
    created() {
        if (this.profileId) {
            this.get_user();
            this.get_notifications();
            this.get_actions();
            this.get_deals();
        }
    },
    data() {
        return {
            profile: [],
            changing_blocked_status: false,
            selectedType : 0,
            selectedChain : 0,
            selectedOffer: '',
            selectedNotifType: 0,
            sortBy: "name",
            filter: "",
            loading_user: false,
            loading_notifications: false,
            loading_actions: false,
            loading_deals: false,
            opened_optional: true,
            opened_deals: true,
            opened_notifications: true,
            opened_utms: true,
            opened_actions: true,
            statuses: PostbackStatuses.get(),
            stat: [],
            payouts: [],
            defaultOpenedDetails: [1],
            showDetailIcon: true,
            nestedColumns: [
                {
                    field: "id",
                    label: "ID",
                    width: "40",
                    numeric: true,
                },
                {
                    field: "created_at",
                    label: "Дата создания",
                },
                {
                    field: "payout",
                    label: "Сумма",
                },
                {
                    field: "currency",
                    label: "Валюта",
                },
                {
                    field: "status",
                    label: "Статус",
                },
            ],
        };
    },
    computed: {
        profileId() {
            return this.$route.params.id;
        },
        opened_details: {
            get() {
                return this.$store.getters.GET_OPENED_DETAILS;
            },
            set(value) {
                this.$store.commit("SET_OPENED_DETAILS", value);
            },
        },

    },
    methods: {
        filter_offers(offers) {
            const filteredOffers = [];
            offers.forEach((element) => { if (!filteredOffers.includes(element.name)) { filteredOffers.push(element.name); } });
            return filteredOffers;
        },
        filter_items(items, offer) {
            if (offer !== '') {
                var result = items.filter(function(obj) {
                    return obj.name === offer;
                });
                return result;
            }
            else {
                return items;
            }
        },
        updateOffer() {
            this.selectedOffer = '';
        },
        type(verificated) {
            if (verificated) {
                return "is-success";
            }
            return "is-danger";
        },
        get_user() {
            let params = {
                id: this.profileId,
            };
            this.loading_user = true;
            this.$store
                .dispatch("GET_USER_BY_ID", params)
                .then((data) => {
                    this.profile = data.data;
                })
                .finally(() => {
                    this.loading_user = false;
                });
        },
        get_notifications() {
            this.loading_notifications = true;
            let params = {
                filters: { id: this.profileId },
                type : 'profile',
            };
            this.$store
                .dispatch("GET_NOTIFICATION_STAT_GROUP_BY_CHAINS", params)
                .then((data) => {
                    this.profile.notifications = data.data.results;
                })
                .finally(() => {
                    this.loading_notifications = false;
                });
        },
        get_actions() {
            let params = {
                id: this.profileId,
            };
            this.loading_actions = true;
            this.$store
                .dispatch("GET_USER_ACTIONS", params)
                .then((data) => {
                    this.profile.actions = data.data;
                })
                .finally(() => {
                    this.loading_actions = false;
                });
        },
        get_deals() {
            let params = {
                sort_by: "id",
                order: "DESC",
                page: "1",
                perPage: "1",
                filters: {
                    id: "",
                    user_id: this.profileId,
                    offer_ids: [],
                    payout: "",
                    currency: "",
                    statuses: [],
                    date: {},
                    registerDate: {},
                },
            };
            this.loading_deals = true;
            this.$store
                .dispatch("GET_DEALS", params)
                .then((data) => {
                    this.profile.deals = data.data.results;
                    this.parseDeals(this.profile.deals);
                })
                .finally(() => {
                    this.loading_deals = false;
                });
        },
        parseDeals(deals) {
            deals.forEach((item) => {
                item.postbackStatusFormatted = "";
                item.postbackPayoutFormatted = "";
                item.postbackAffSub4 = "";

                if (item.postbacks && item.postbacks.length) {
                    const postback = item.postbacks[item.postbacks.length - 1];
                    if (postback) {
                        item.postbackStatusFormatted = postback.status;
                        item.postbackPayoutFormatted = postback.payout;
                        item.postbackAffSub4 = postback.aff_sub4;
                        item.postbackCurrency = postback.currency;
                    }
                }
            });
        },
        switch_show(value) {
            // this.$store.dispatch('SET_OPENED_DETAILS', value);
            this.opened_optional = value;
        },
        changeBlock() {
            let params = {
                id: this.profile.id,
                status: this.profile.is_sms_blocked,
            };
            this.changing_blocked_status = true;
            this.$store
                .dispatch("CHANGE_IF_SMS_BLOCKED", params)
                .then(() => {
                    this.$toaster.success("Статус смс обновлен");
                })
                .catch(() => {
                    this.$toaster.error("Неизвестная ошибка!");
                })
                .finally(() => {
                    this.changing_blocked_status = false;
                });
        },
    },
};
</script>

<style scoped>
.verificated {
    color: #30a838 !important;
}
.not_verificated {
    color: #e20000 !important;
}
.approved {
    color: #30a838;
}
.pending {
    color: #f7e838;
}
.rejected {
    color: #e20000;
}
</style>
